/** create by fwt on 2018-8-20*/
import React, { Component } from 'react';
import { DatePicker,InputItem,Calendar,Modal, NavBar, Toast, Carousel, NoticeBar, Icon } from 'antd-mobile';
import { txsuggestion,txgetLocation,searchBytime,getShiftList,checkRange,historyStation,endCity,getPoi, startCity, getHot, getNearSite, getSignature, getCityList, unfinishedOrder, getorderinfo,getUserHotAddress,changeUserHotAddress,delUserHotAddress } from '../../service/homeService';
import ReconnectingWebSocket from 'reconnecting-websocket';
import CityModal from '../../components/CityModal';
import CharteredBus from './CharteredBus';
import RunCar from "./RunCar";
import BringGoods from "./BringGoods";
import InsideCity from './InsideCity';
import Lottie from 'react-lottie';
import * as mapData from '../../config/mapData'
import * as animationData from '../../config/userPosition'
import { connect } from "react-redux";
import BMap from "BMap";
import './style.less';
import moment from 'moment';
import {lxddtappId,wss} from "../../config/config";

// 把rws 定义在外面是方便断开连接
let rws = null;
const gzbg = require('../../common/image/gzbg.jpg');
const ynbg = require('../../common/image/ynbg.jpg');
const qianbao = require('../../common/image/qianbao.png');
const mtlogo = require('../../common/image/mtlogo.png');
const interCity = require('../../common/image/Group 4 copy@2x.png');
const rentCar = require('../../common/image/2017122907511839515@2x.png');
const rentCity = require('../../common/image/d902.png');
const taxi = require('../../common/image/taxi@2x.png');
const qb1 = require('../../common/image/qb1.png');

const c1 = require('../../common/image/v2/ic1.png');
const c2 = require('../../common/image/v2/ic2.png');
const c3 = require('../../common/image/v2/ic3.png');
const c4 = require('../../common/image/v2/ic4.png');
const c5 = require('../../common/image/v2/ic5.png');
const c6 = require('../../common/image/v2/ic6.png');
const c7 = require('../../common/image/v2/ic7.png');
const c8 = require('../../common/image/v2/ic8.png');
const c9 = require('../../common/image/v2/ic9.png');
const banner = require('../../common/image/v2/banner.png');
const banner1 = require('../../common/image/v2/banner1.png');
const car = require('../../common/image/v2/car.png');
const b1 = require('../../common/image/v2/b1.png');
const b2 = require('../../common/image/v2/b2.png');
const b3 = require('../../common/image/v2/b3.png');

const userPosition = require('../../common/image/userPosition.png');
const guanggao = require('../../common/image/v2/guanggao20230705.png');


let map, ls, geolocation, gc, poi, marker,markerLayer;
let nearbySite = [];
let initTabPage = 0;
let websocketTime = "";
let checkDragend = true;
const now = new Date();
@connect(
    state => ({ userInfo: state.userInfo })
)
export default class Home extends Component {
    originbodyScrollY = document.getElementsByTagName('body')[0].style.overflowY;
    constructor(props) {
        super(props);
        this.state = {
            // bgModal:false,
            tabs: [
                { title: "预约出行" },
                { title: "专车预约" },
                { title: "市内约车" },
                { title: "接送站" },
                { title: "带货" },
            ],
            tabIndex: initTabPage,
            modalImage: [
                { url: interCity, name: '城际出行' },
                { url: rentCar, name: '包车' },
                { url: rentCity, name: '城内约车' },
                { url: taxi, name: '出租车' },
                { url: '', name: '' },
                { url: '', name: '' },
            ],
            interCityModal: true,
            indexModal: false,
            searchModal: false,
            cityModal: false,
            mapModel:false,
            searchValue: '',//搜索地址的值
            citySearch: '',//搜索城市的值
            poiList: [],//搜索地址列表
            hotData: [],
            cityData: [],
            modalType: 'start',
            cityType: 'intercity',//城市类型（城际intercity/城内city）
            position: { top: 0, left: 0, },
            startAddress: "哪儿上车？",
            endAddress: "您想去哪？",
            currentCity: "",//所在位置城市名
            startCity: "",//选择开始城市改变
            userPoint: "",
            errorTips: [
                '',
                '您当前所在位置超出接送范围！',
                '超出接送范围，请重新选择！',
                '坐标位置',
            ],
            curTips: '',
            isError: false,
            point: '',
            isStopped: false,
            nearbySite: "",
            carListTow: [],
            initCarList: [],
            province: "",
            historyAddress: {},
            orderinfo: "",//最新出行的订单信息
            show:false,
            config: {},
            startDateVal:moment(now).format('YYYY-MM-DD'),
            poiListFlag:true,
            currentEndCity:'',
            historyDatas:[],
            cjstartPoi:'',
            cjendPoi:'',
            lineIds:[],
            timeselected:[],
            shiftData:{},
            cityStartCity:"",
            cityStartAddress:"",
            visible:false,
            classData:[],
            district:"",
            markers:[],
            modal:false,
            setaddressmodal:false,
            currentChange:'',
            cityhistoryData:{
                homeAddress:{address:''},
                companyAddress:{address:''},
                startAddress:[],
                endAddress:[],
            },
        };
    }

    componentDidMount() {
        // if(sessionStorage.getItem('bgImg') == 'no'){
        //     this.setState({bgModal:true});
        // }
        this.getAddress()
        map = null;
        markerLayer = null;
        geolocation = null;
        gc = null;
        rws = null
        if (localStorage.getItem("tabType") !== null) {
            localStorage.removeItem("tabType");
        }
        this.checkOrder();
        this.getlastseen();
        getSignature(window.location.href.split('?')[0]).then((res) => {
            if (res.data.code == '0000') {
                window.wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: res.data.data.appId, // 必填，公众号的唯一标识
                    timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
                    signature: res.data.data.signature,// 必填，签名
                    jsApiList: [
                        'getLocation',
                    ], // 必填，需要使用的JS接口列表
                    openTagList: ["wx-open-launch-weapp"],
                });
                window.wx.ready(() => {
                    Toast.loading('正在定位', 30);
                    this.getLocation();
                    if (this.state.tabIndex == 0) {
                        this.getHotData();
                    }
                    // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
                });
                window.wx.error((n) => {
                    if (n.errMsg == 'config:invalid signature') {
                        // alert(JSON.stringify(n) + "签名失败应该刷新");
                        window.location.reload()
                    }
                    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                });
            } else {
                Toast.info(res.data.msg)
            }
        });

    }
    getAddress(){
        let params = {
            source: 1,
            token: this.props.userInfo.token,
        };
        getUserHotAddress(params).then((res)=>{
            this.setState({cityhistoryData:res.data.data})
        })
    }
    getlastseen() {
        let params = {
            source: 1,
            token: this.props.userInfo.token,
        };
        getorderinfo(params).then((res) => {
            if (res.data.code == '0000' && res.data.data) {
                this.setState({ orderinfo: res.data.data });
            }
        })
    }
    checkOrder() {
        let params = {
            source: 1,
            token: this.props.userInfo.token,
        };
        unfinishedOrder(params).then((res) => {
            if (res.data.code === '0000') {
                if (res.data.data !== false) {
                    if (initTabPage == 2) {
                        Modal.alert('', <div>您有正在进行的城内订单，是否进入查看？</div>, [
                            { text: '取消', style: { background: "#DADCDE", color: "#ACACAC", fontSize: "14px", height: "48px" } },
                            {
                                text: '进入', style: { background: "#3679FE", color: "#FFFFFF", fontSize: "14px", height: "48px" }, onPress: () => {
                                    unfinishedOrder(params).then((res) => {
                                        if (res.data.code === '0000') {
                                            if (res.data.data == false) {
                                                Toast.info("您的订单已超时，已自动取消");
                                            } else {
                                                if (res.data.data.isFirstPay) {
                                                    this.props.history.push('/rideCar',{orderId:res.data.data.orderId});
                                                } else {
                                                    this.props.history.push('/RideCarPay',{orderId:res.data.data.orderId});
                                                }
                                            }
                                        }
                                    });
                                }
                            },
                        ]);
                    }
                }
            } else {
                Toast.info(res.data.msg)
            }
        })
    }
    setRotation(startPoi, endPoi) {
        let deg = 0;
        // startPoi = map.pointToPixel(startPoi);
        // endPoi = map.pointToPixel(endPoi);
        startPoi = map.projectToContainer(startPoi);
        endPoi = map.projectToContainer(endPoi);
        if (endPoi.x != startPoi.x) {
            let tan = (endPoi.y - startPoi.y) / (endPoi.x - startPoi.x);
            let atan = Math.atan(tan);
            deg = atan * 360 / (2 * Math.PI);
            if (endPoi.x < startPoi.x) {
                deg = parseInt(-deg + 90 + 90);
            } else {
                deg = -deg;
            }
            deg = -deg;
        } else {
            let disy = endPoi.y - startPoi.y;
            let bias = 0;
            if (disy > 0)
                bias = -1;
            else
                bias = 1;
            deg = -bias * 90;
        }
        return deg
    }
    setRotation(l, startPoint,endPoint) {
        var j = this;
        var x = endPoint.lng-startPoint.lng;//lng-经度，lat-纬度
        var y = endPoint.lat-startPoint.lat;
        if(x==0){
            return j._marker.setRotation(0);
        }
        if(x>0){
            var z=Math.sqrt(x*x+y*y);
            var jiaodu=Math.round((Math.asin(y/z)/Math.PI*180));//最终角度
            if(jiaodu>=0){
                return j._marker.setRotation(180-jiaodu);
            }else{
                return j._marker.setRotation(180+Math.abs(jiaodu));
            }
        }
        if(x<0){
            var z=Math.sqrt(x*x+y*y);
            var jiaodu=Math.round((Math.asin(y/z)/Math.PI*180));//最终角度
            if(jiaodu>=0){
                return j._marker.setRotation(jiaodu);
            }else{
                return j._marker.setRotation(360-Math.abs(jiaodu));
            }
        }
    }
    initWebsocket(obj) {
        if (!rws) {
            rws  =  new  ReconnectingWebSocket(wss);
        }
        rws.addEventListener("open", async () => {
            if (!rws) return;
            if (rws.readyState === 1) {
                // 这个是你给websocket 传输它要的东西
                rws.send(obj);
            }
        });
        rws.addEventListener("message", e => {
            //你可以调用action 来触发消息给页面上展示 例如 这些消息方法需要你自己来封装
            let data = JSON.parse(e.data);
            // map.clearOverlays();
            // this.removeMarker()
            console.log(data.data)
            if (data.code == 200) {
                // if (this.state.initCarList.length > 0) {
                //     if (data.data.length > 0) {
                //         for (let i = 0; i < this.state.initCarList.length; i++) {
                //             if (data.data[i].driverId == this.state.initCarList[i].driverId) {
                //                 if (data.data[i].longitude !== this.state.initCarList[i].longitude || data.data[i].latitude !== this.state.initCarList[i].latitude) {
                //                     let startPoi = new BMap.Point(this.state.initCarList[i].longitude, this.state.initCarList[i].latitude);
                //                     let endPoi = new BMap.Point(data.data[i].longitude, data.data[i].latitude);
                //                     let point = new BMap.Point(data.data[i].longitude, data.data[i].latitude);
                //                     this.addMarker(point, this.setRotation(startPoi, endPoi));
                //                 } else {
                //                     let point = new BMap.Point(data.data[i].longitude, data.data[i].latitude);
                //                     this.addMarker(point);
                //                 }
                //             } else {
                //                 let point = new BMap.Point(data.data[i].longitude, data.data[i].latitude);
                //                 this.addMarker(point);
                //             }
                //         }
                //     }
                // } else {
                //     data.data.map((res) => {
                //         let point = new BMap.Point(res.longitude, res.latitude);
                //         this.addMarker(point);
                //     });
                //     this.setState({ initCarList: data.data });
                // }

                if (this.state.initCarList.length > 0) {
                    if (data.data.length > 0) {
                        for (let i = 0; i < this.state.initCarList.length; i++) {
                            if (data.data[i].driverId == this.state.initCarList[i].driverId) {
                                if (data.data[i].longitude !== this.state.initCarList[i].longitude || data.data[i].latitude !== this.state.initCarList[i].latitude) {
                                    // let startPoi = new BMap.Point(this.state.initCarList[i].longitude, this.state.initCarList[i].latitude);
                                    // let endPoi = new BMap.Point(data.data[i].longitude, data.data[i].latitude);
                                    // let point = new BMap.Point(data.data[i].longitude, data.data[i].latitude);
                                    // console.log(this.setRotation(startPoi, endPoi))
                                } else {
                                    // let point = new BMap.Point(data.data[i].longitude, data.data[i].latitude);
                                    // this.addMarker(point);
                                }
                            } else {
                                // let point = new BMap.Point(data.data[i].longitude, data.data[i].latitude);
                                // this.addMarker(point);
                            }
                        }
                    }
                } else {
                    let arr = data.data.map((point) => {
                        return {
                            id: point.driverId,
                            styleId: 'myStyle',
                            position: new window.TMap.LatLng(point.latitude, point.longitude),
                        }
                    });
                    markerLayer.add(arr)
                    this.setState({ initCarList: data.data });
                }
                let arr1=[{
                    "id": "1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
                    "styleId": 'myStyle',  //指定样式id
                    "position": new window.TMap.LatLng(25.01503,102.7437),  //点标记坐标位置
                    }, {
                        "id": "2",
                        "styleId": 'myStyle',
                        "position": new window.TMap.LatLng(25.00834,102.751308),
                    },{
                        "id": "3",
                        "styleId": 'myStyle',
                        "position": new window.TMap.LatLng(25.014474,102.744624),
                    },{
                        "id": "4",
                        "styleId": 'myStyle',
                        "position": new window.TMap.LatLng(25.013518,102.742176),
                    },{
                        "id": "5",
                        "styleId": 'myStyle',
                        "position": new window.TMap.LatLng(25.016404,102.743729),
                    },{
                        "id": "6",
                        "styleId": 'myStyle',
                        "position": new window.TMap.LatLng(25.015358,102.741181),
                    },{
                        "id": "7",
                        "styleId": 'myStyle',
                        "position": new window.TMap.LatLng(25.014798,102.743629),
                    }
                ]
                

                // console.log(data.data)
                // markerLayer.setStyles({"myStyle": new window.TMap.MarkerStyle({
                //     // "width": 70,
                //     // "height":  68,
                //     // "src": 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerNew.png',
                //     "opacity": 0.5
                // })})
            }
        });
    }
    getHotData() {
        getHot({ source: 1, token: this.props.userInfo.token, }).then((res) => {
            if (res.data.code == '0000') {
                this.setState({ hotData: res.data.data })
            }
        });
    }
    getNearSiteData(position) {
        getNearSite({ source: 1, token: this.props.userInfo.token, data: { position:position } }).then((res) => {
            if (res.data.code == '0000') {
                nearbySite = res.data.data;
            }
        })
    }
    getLocation() {
        map = new window.TMap.Map('mapContainer',{zoom: 17.2});
        // map = new BMap.Map('mapContainer');
        // let convertor = new BMap.Convertor();
        // gc = new BMap.Geocoder();
        const self = this;
        window.wx.getLocation({
            // altitude:true,
            // isHighAccuracy:true,
            // highAccuracyExpireTime:3100,
            type:'gcj02',
            success: (r) => {
                Toast.hide();
                let center = new window.TMap.LatLng(r.latitude, r.longitude)
                map.setCenter(center);
                map.removeControl(window.TMap.constants.DEFAULT_CONTROL_ID.ZOOM);
                map.removeControl(window.TMap.constants.DEFAULT_CONTROL_ID.ROTATION);
                map.removeControl(window.TMap.constants.DEFAULT_CONTROL_ID.SCALE);
                let params = {
                    source: 1,
                    token: self.props.userInfo.token,
                    data:{location:r.latitude+','+r.longitude,get_poi:1}
                };
                txgetLocation(params).then((res)=>{
                    let result = res.data.data.result
                    self.setState({
                        province: result.address_component.province,
                        currentCity: result.address_component.city,
                        startCity: result.address_component.city,
                        cityStartCity:result.address_component.city,
                        district:result.address_component.district,
                    });
                    console.log(result)
                    if (result.poi_count > 0) {
                        let firstPoint = result.pois[0];
                        self.setData(self, firstPoint.title, firstPoint.location.lng, firstPoint.location.lat, true, 0,firstPoint.ad_info.adcode);
                    }
                    if (result.poi_count == 0 && result.address_component.street !== "") {
                        self.setData(self, result.address_component.street + result.address_component.street_number, result.location.lng, result.location.lat, true, 0,result.ad_info.adcode);
                    }
                    if (result.poi_count == 0 && result.address_component.street == "") {
                        self.setData(self, '坐标位置', result.location.lng, result.location.lat, true, 0,result.ad_info.adcode);
                    }
                })
                let pixel = map.projectToContainer(center);
                self.setState({
                    userPoint: center,
                    position: { top: pixel.y, left: pixel.x, },
                });
                this.addMarker();
                if (initTabPage == 2) {
                    this.setState({cityType:'city'})
                    let data = {
                        "command": "near",
                        "data": {
                            "id": this.props.userInfo.userId,
                            "longitude": r.longitude,
                            "latitude": r.latitude
                        }
                    };
                    websocketTime = setInterval(() => {
                        this.initWebsocket(JSON.stringify(data));
                    }, 10000);
                }
                self.getNearSiteData(r.longitude+'_'+r.latitude);
                // convertor.translate([{ lng: r.longitude, lat: r.latitude }], 1, 5, (data) => {
                    // console.log(data)
                    // let point = new BMap.Point(data.points[0].lng, data.points[0].lat);
                    // console.log(point)
                    // map.centerAndZoom(point, 17);
                    // // 当前经纬度转换像素坐标点在地图上显示当前位置图标
                    // let pixel = map.pointToPixel(point);
                    // console.log(pixel)
                    // self.setState({
                    //     userPoint: point,
                    //     position: { top: pixel.y, left: pixel.x, },
                    // });
                    // if (initTabPage == 2) {
                    //     this.setState({cityType:'city'})
                    //     let data = {
                    //         "command": "near",
                    //         "data": {
                    //             "id": this.props.userInfo.userId,
                    //             "longitude": point.lng,
                    //             "latitude": point.lat
                    //         }
                    //     };
                    //     websocketTime = setInterval(() => {
                    //         this.initWebsocket(JSON.stringify(data));
                    //     }, 10000);
                    // }
                    //通过经纬度获取当前具体位置
                    // self.getNearSiteData(data.points[0].lat + "_" + data.points[0].lng);
                    // gc.getLocation(new BMap.Point(data.points[0].lng, data.points[0].lat), function (res) {
                    //     console.log(res)
                    //     self.setState({
                    //         province: res.addressComponents.province,
                    //         currentCity: res.addressComponents.city,
                    //         startCity: res.addressComponents.city,
                    //         cityStartCity:res.addressComponents.city,
                    //         district:res.addressComponents.district,
                    //     });
                    //     if (res.surroundingPois.length > 0) {
                    //         let firstPoint = res.surroundingPois[0];
                    //         self.setData(self, firstPoint.title, firstPoint.point.lng, firstPoint.point.lat, true, 0);
                    //         self.setState({
                    //             poiList: res.surroundingPois,
                    //         });
                    //     }
                    //     if (res.surroundingPois.length == 0 && res.addressComponents.street !== "") {
                    //         self.setData(self, res.addressComponents.street + res.addressComponents.streetNumber, res.point.lng, res.point.lat, true, 0);
                    //     }
                    //     if (res.surroundingPois.length == 0 && res.addressComponents.street == "") {
                    //         self.setData(self, '当前位置', data.points[0].lng, data.points[0].lat, true, 0);
                    //     }
                    // })
                // })
            },
            cancel: (r) => {
                Toast.hide();
                alert("用户拒绝获取地理位置")
            },
        });
        map.on("panend",function(){
            if(checkDragend){
                let location = map.getCenter().toString().replace(/\s/ig, '')
                self.getLocationBytx(self,location.split(',')[0]+','+location.split(',')[1])
            }
        })
        // ls = new BMap.LocalSearch(map, {
        //     onSearchComplete: (res) => {
        //         let s = [];
        //         if (res) {
        //             for (var i = 0; i < res.getCurrentNumPois(); i++) {
        //                 s.push(res.getPoi(i))
        //             }
        //             self.setState({
        //                 poiList: s,
        //             });
        //         }
        //     },
        // });
        
        // map.addEventListener('dragend', function (e) {
        //     self.setState({ isStopped: true });
        //     gc.getLocation(e.point, function (res) {
        //         if (res.surroundingPois.length > 0) {
        //             let firstPoint = res.surroundingPois[0];
        //             self.setData(self, firstPoint.title, firstPoint.point.lng, firstPoint.point.lat, true, 0);
        //             self.setState({ poiList: res.surroundingPois, });
        //         }
        //         if (res.surroundingPois.length == 0 && res.addressComponents.street !== "") {
        //             self.setData(self, res.addressComponents.street + res.addressComponents.streetNumber, res.point.lng, res.point.lat, true, 0);
        //         }
        //         if (res.surroundingPois.length == 0 && res.addressComponents.street == "") {
        //             self.setData(self, '坐标位置', e.point.lng, e.point.lat, true, 0);
        //         }
        //         self.setState({ isStopped: false });
        //     });
        //     let pixel = map.pointToPixel(self.state.userPoint);
        //     self.setState({ position: { top: pixel.y, left: pixel.x, }, });
        // });
    }
    getLocationBytx(self,location){
        self.setState({ isStopped: true });
        let params = {
            source: 1,
            token: self.props.userInfo.token,
            data:{location:location,get_poi:1}
        };
        txgetLocation(params).then((res)=>{
            let result = res.data.data.result
            if (result.poi_count > 0) {
                let firstPoint = result.pois[0];
                self.setData(self, firstPoint.title, firstPoint.location.lng, firstPoint.location.lat, true, 0,firstPoint.ad_info.adcode);
                // self.setState({poiList: result.pois,});
            }
            if (result.poi_count == 0 && result.address_component.street !== "") {
                self.setData(self, result.address_component.street + result.address_component.street_number, result.location.lng, result.location.lat, true, 0,result.ad_info.adcode);
            }
            if (result.poi_count == 0 && result.address_component.street == "") {
                self.setData(self, '坐标位置', result.location.lng, result.location.lat, true, 0,result.ad_info.adcode);
            }
            self.setState({ isStopped: false });
        })
    }
    setData = (self, title, lng, lat, boolean, index,adcode) => {
        if(this.state.cityType == 'city'){
            this.setState({
                cityStartAddress: title,
                isError: boolean,
                curTips: title,
            });
        }
        if(this.state.cityType == 'intercity'){
            this.setState({
                startAddress: this.state.modalType == 'start' ? title :this.state.startAddress,
                endAddress:this.state.modalType == 'end' ? title :this.state.endAddress,
                cjstartPoi:this.state.modalType == 'start' ? lat+'_'+lng :this.state.cjstartPoi,
                cjendPoi:this.state.modalType == 'end' ? lat+'_'+lng  :this.state.cjendPoi,
                isError: boolean,
                curTips: title,
            });
        }
        poi = {
            lng: lng,
            lat: lat,
            address: title,
            adcode:adcode,
        };
    };

    // 选择上下车点击
    address = (type, tabType, nowType, appointmentTime) => {
         //城内选择城市
         if (type === "selCity") {
            this.cityStartList()
            //城内搜索上车地址
        } else if (type === "cityStart") {
            this.setState({ searchModal: true, poiList: [], });
            checkDragend = false
            setTimeout(() => {
                this.autoFocusInst.focus();
            }, 500);
            //城内或者城际选择下车地址
        } else if (type === "end") {
            if (this.state.cityStartAddress == '哪儿上车？') {
                Toast.info("请先输入上车地址！");
                return
            }
            if (poi.address == '坐标位置') {
                poi.address = "坐标(" + poi.lng + ',' + poi.lat + ")"
            }
            if (tabType == "city") {
                let params = {
                    type: type,//出发或者到达
                    startPoi: poi,
                    startCity: this.state.cityStartCity,
                    cityType: tabType,//当前类型 城内或城际
                    nowType: nowType,//0：现在1:预约
                    appointmentTime: appointmentTime,
                };
                this.props.history.push('/citySelAddress', params);
            } else {
                let params = {
                    type: type,
                    startPoi: poi,
                    startCity: this.state.startCity,
                    currentCity: this.state.currentCity,
                    userPoint: this.state.userPoint,
                    cityType: tabType,
                };
                this.props.history.push('/selAddress', params);
            }
        }
    };
    cityStartList() {
        this.setState({ cityModal: true, cityType: "city",modalType:'' });
        const params = {
            source: 1,
            token: this.props.userInfo.token,
        };
        Toast.loading('正在加载', 0);
        getCityList(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.hide();
                this.setState({ cityData: res.data.data });
            } else {
                Toast.info(res.data.msg, 3)
            }
        })

    }

    onClose = () => {
        this.setState({
            cityModal: false,
            cityData: [],
            citySearch: '',
            bgModal: false,
            mapModel:false,
        });
        sessionStorage.removeItem('bgImg')
    };
    searchChange = (value) => {
        this.setState({ searchValue: value ,poiListFlag:true});
        this.tabDOM.scrollTop = 0;
        if(value){
            let params = {
                source: 1,
                token: this.props.userInfo.token,
                data:{location:poi.lat+','+poi.lng,keyword:value}
            };
            txsuggestion(params).then((res)=>{
                res.data.data.data.map((r)=>{
                    r.point = r.location
                })
                this.setState({poiList:res.data.data.data,});
            })
        }
        // ls.search(value);
    };
    // 搜索地址选择
    selPoi(res) {
        if(res.code){
            map.setCenter(new window.TMap.LatLng(res.location.split('_')[0], res.location.split('_')[1]));
            this.setData(this, res.address, res.location.split('_')[1], res.location.split('_')[0], true, 0,res.code);
        }else{
            map.setCenter(new window.TMap.LatLng(res.point.lat, res.point.lng));
            this.setData(this, res.title, res.point.lng, res.point.lat, true, 0,res.adcode);
        }
        // if (res.title == '昆明市') {
        //     // map.centerAndZoom(new BMap.Point(102.738151, 25.082654), 17);
        //     map.setCenter(new window.TMap.LatLng(25.082654, 102.738151));
        //     this.setData(this, "民途出行北市区集散中心", 102.738151, 25.082654, true, 0,res.adcode);
        // } else {
        //     // if (res.name !== null) {
        //     //     map.centerAndZoom(new BMap.Point(res.point.lng, res.point.lat), 17);
        //     // } else {
        //     //     map.centerAndZoom(res.point, 17);
        //     // }
        //     map.setCenter(new window.TMap.LatLng(res.point.lat, res.point.lng));
        //     this.setData(this, res.title, res.point.lng, res.point.lat, true, 0,res.adcode);
        // }
        let pixel = map.projectToContainer(this.state.userPoint);
        // let pixel = map.pointToPixel(this.state.userPoint);
        this.setState({ position: { top: pixel.y, left: pixel.x, }, searchModal: false, searchValue: '',mapModel:false});
    }

    backHome() {
        checkDragend = true
        this.setState({ searchModal: false, searchValue: '' });
    }

    changeCity(n) {
        checkDragend = false;
        map.setCenter(new window.TMap.LatLng(n.lat,n.lng));
        // map.centerAndZoom(new BMap.Point(n.lng, n.lat), 17);
        this.setData(this, n.address, n.lng, n.lat, true, 0);
        if(this.state.modalType == 'start'){
            this.setState({ mapModel:true,poiList: [], cityModal: false, startCity: n.name, position: { top: 0, left: 0, }, });
        }
        if(this.state.modalType == 'end'){
            this.setState({ mapModel:true,poiList: [], cityModal: false, currentEndCity:n.name, position: { top: 0, left: 0, }, });
        }
        if(this.state.cityType == 'city'){
            this.setState({ searchModal:true,poiList: [], cityModal: false, cityStartCity:n.name, position: { top: 0, left: 0, }, });
        }
        let params = {
            source: 1,
            token: this.props.userInfo.token,
            data: {
                stattionId: n.stattionId,
                startLocation: n.lat + ',' + n.lng,
            }
        };
        getPoi(params).then((res) => {
            if (res.data.code == '0000') {
                this.setState({ poiList: res.data.data,poiListFlag:true });
            } else {
                Toast.info(res.data.msg)
            }
        });
        setTimeout(() => {
            this.autoFocusInst.focus();
        }, 500);
    }

    goSelClass(val){
        console.log(val,this.state.modalType)
        if(val){
            this.setData(this, val.title, val.point.lng, val.point.lat, true, 0);
        }
        if(this.state.modalType == 'end'){
            Toast.loading("");
            let checkParams = {
                source: 1,
                token:this.props.userInfo.token,
                data:{
                    startPosition:this.state.cjstartPoi,
                    endPosition:val?val.point.lat+'_'+val.point.lng:this.state.cjendPoi,
                }
            };
            checkRange(checkParams).then((res)=>{
                if(res.data.code == "0000"){
                    Toast.hide();
                    if(this.state.endAddress == '坐标位置'){
                        this.setState({endAddress:"坐标("+val.point.lng + ','+val.point.lat+")"});
                    }
                    let params = {
                        startCity:this.state.startCity,
                        startAddress:this.state.startAddress,
                        startPosition:this.state.cjstartPoi,
                        endCity:this.state.currentEndCity,
                        endAddress:this.state.endAddress,
                        endPosition:val?val.point.lat+'_'+val.point.lng:this.state.cjendPoi,
                        lineIds:res.data.data,
                        type:'address',
                    };
                    this.props.history.push('/selectShift',{...params});
                }else{
                    Toast.info(res.data.msg)
                }
            });
        }else{
            this.closeaddress()
        }
        
    }

    closeaddress(){
        this.setState({
            mapModel:false,
            searchValue: '',
            poiList:[],
            poiListFlag:true,
            endAddress:"您想去哪？",
            cjendPoi:""
        })
    }

    //搜索上车地址
    searchChangeCity() {
        return (
            <Modal
                className="searchModal"
                visible={this.state.searchModal}
                maskClosable={false}
            >
                <div className="topBar">
                    <div className='box'>
                        <i className="icon iconfont iconfanhui" onClick={() => this.backHome()} />
                        <div className='circleS'></div>
                        <InputItem
                            className="searchBar"
                            ref={ref => this.autoFocusInst = ref}
                            value={this.state.searchValue}
                            placeholder="请输入起点"
                            onChange={this.searchChange}
                        ></InputItem>
                    </div>
                </div>
                <div className="poiList" ref={dom => { this.tabDOM = dom }}>
                    <div className='setAddressbox' style={this.state.poiListFlag === false  ? {display:'none'} : null}>
                        <div className='setAddress'>
                            <div className='home flex'>
                                <i className="icon iconfont iconjiating"/>
                                <div className='text'>
                                    <p className='name'>家庭</p>
                                    <p className='address' onClick={()=>{
                                        if(this.state.cityhistoryData.homeAddress == null){
                                            this.setState({currentChange:'家庭',setaddressmodal:true,searchValue:'',poiList: [],})
                                        }else{
                                            this.selPoi(this.state.cityhistoryData.homeAddress)
                                        }
                                    }}>{this.state.cityhistoryData.homeAddress? this.state.cityhistoryData.homeAddress.address:'未设置家庭地址'}</p>
                                </div>
                                <i className="icon iconfont iconzhongjiansanyuan" onClick={()=>{
                                    if(this.state.cityhistoryData.homeAddress == null){
                                        this.setState({currentChange:'家庭',setaddressmodal:true,searchValue:'',poiList: [],})
                                    }else{
                                        this.setState({currentChange:'家庭',modal:true})
                                    }
                                }}/>
                            </div>
                            <div className='height'></div>
                            <div className='company flex'>
                                <i className="icon iconfont icongongsi"/>
                                <div className='text'>
                                    <p className='name'>公司</p>
                                    <p className='address' onClick={()=>{
                                        if(this.state.cityhistoryData.companyAddress == null){
                                            this.setState({currentChange:'公司',setaddressmodal:true,searchValue:'',poiList: [],})
                                        }else{
                                            this.selPoi(this.state.cityhistoryData.companyAddress)
                                        }
                                    }}>{this.state.cityhistoryData.companyAddress? this.state.cityhistoryData.companyAddress.address:'未设置公司地址'}</p>
                                </div>
                                <i className="icon iconfont iconzhongjiansanyuan" onClick={()=>{
                                    if(this.state.cityhistoryData.companyAddress == null){
                                        this.setState({currentChange:'公司',setaddressmodal:true,searchValue:'',poiList: [],})
                                    }else{
                                        this.setState({currentChange:'公司',modal:true})
                                    }
                                }}/>
                            </div>
                        </div>
                        <div className="mapSel" onClick={() => this.backHome()}><i className="icon iconfont iconditushangxuandian" />在地图上选点</div>
                    </div>
                    <div className="list1">
                        {
                            this.state.cityhistoryData.startAddress.map((res, i) => (
                                <div className="item"  key={i}  onClick={() => this.selPoi(res)} >
                                    <i className="icon iconfont iconlishi"/>
                                    <div>
                                        <div>{res.title}</div>
                                        <span>{res.address}</span>
                                    </div>
                                </div>

                            ))
                        }
                    </div>
                    {
                        this.state.poiList.length > 0 ? (
                            <div className="list">
                                {
                                    this.state.poiList.map((res, i) => (
                                        <div className="item" key={i} onClick={() => this.selPoi(res)} >
                                            <i className="icon iconfont icondituliebiaotubiao" />
                                            <div>
                                                <div>{res.title}</div>
                                                <span>{res.address}</span>
                                            </div>
                                        </div>

                                    ))
                                }
                            </div>
                        ) : <div className='tishi'>请输入搜索内容</div>
                    }

                </div>
            </Modal>
        )
    }
    tabChange = (v, index) => {
        setTimeout(() => {
            this.setState({ tabIndex: index, cityData: [],modalType:'start' });
            initTabPage = index;
            map.destroy();
            this.getLocation();
            // map.clearOverlays();
            // this.removeMarker()
            if (index == 0) {
                this.setState({ cityType: "intercity" });
            }
            if (index == 2) {
                this.checkOrder();
                this.setState({cityType:"city"});
            }
        }, 100);
    };
   
    addMarker(point, rotation) {
        if(!markerLayer){
            markerLayer = new window.TMap.MultiMarker({
                map: map,  //指定地图容器
                //样式定义
                styles: {
                    //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
                    "myStyle": new window.TMap.MarkerStyle({ 
                        "width": 30,  // 点标记样式宽度（像素）
                        "height": 25, // 点标记样式高度（像素）
                        "src": 'https://download.ynsjj88.com/20240301144923.png',  //图片路径
                        //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
                        "anchor": { x: 16, y: 32 }  
                    }) 
                },
                // geometries:arr1
            });
        }
        // let myIcon = new BMap.Icon(require('../../common/image/carIcon.png'), new BMap.Size(40, 80), {
        //     offset: new BMap.Size(30, 25), // 指定定位位置
        // });
        // marker = new BMap.Marker(point, { icon: myIcon });
        // map.addOverlay(marker);
        // marker.setRotation(rotation)
    }
    removeMarker() {
        if (markerLayer) {
            markerLayer.setMap(null);
            markerLayer = null;
        }
    }
    changeBody() {
        if (this.state.tabIndex == 0 && !this.state.mapModel) {
            return (
                <div className='newhome'>
                    <div className='bannerdiv'>
                        <img src={banner}></img>
                    </div>
                    <div className='homecontent'>
                        <div className='notice'>
                            <div className='noticentxt'>
                                <NoticeBar icon={<Icon type="voice" size="md" />} color='alert' marqueeProps={{ loop: true }}>
                                    有乘飞机、高铁、火车的乘客，请预留足够时间安排出行！应国家相关法律法规的要求，婴幼儿乘车需要计费。
                                </NoticeBar>
                            </div>
                        </div>
                        <div className='inputdiv'>
                            <div className="area">
                                <div className="site">
                                    <div className="start">
                                        <i className="icon iconfont iconqidian" />
                                        <div onClick={() => this.getStartCityList(this.state.province)}>
                                            <p>从哪出发？</p>
                                            <div className="startSite" >
                                                {this.state.startAddress}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="end">
                                        <i className="icon iconfont iconzhongdian" />
                                        <div onClick={() => this.getEndCityList()}>
                                            <div className="endSite">
                                               {this.state.endAddress}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='timebox' >
                            {/* <div className='timebox' onClick={() => this.timeChange()}> */}
                                <i className="icon iconfont iconlishijilu" />
                                <span>{this.state.startDateVal}</span>
                            </div>
                        </div>
                        <div className='menupic'>
                            {/* <div className='mu'>
                                <img src={c1} ></img>
                                <div className='ctxt'>预约出行</div>
                            </div> */}
                            <div className='mu' onClick={() => this.tabChange(0, 2)}>
                                <img src={c3} ></img>
                                <div className='ctxt'>快车</div>
                            </div>
                            <div className='mu' onClick={() => this.tabChange(0, 1)}>
                                <img src={c2} ></img>
                                <div className='ctxt'>专车预约</div>
                            </div>
                            <div className='mu' onClick={() => this.tabChange(0, 3)}>
                                <img src={c4} ></img>
                                <div className='ctxt'>接送站</div>
                            </div>
                            <div className='mu' onClick={() => this.tabChange(0, 4)}>
                                <img src={c5} ></img>
                                <div className='ctxt'>带货</div>
                            </div>
                            <div className='mu' onClick={() => this.props.history.push('/empty')}>
                                <img src={c7} ></img>
                                <div className='ctxt'>顺风车</div>
                            </div>
                            <div className='mu' onClick={() => this.props.history.push('/empty')}>
                                <img src={c8} ></img>
                                <div className='ctxt'>租车</div>
                            </div>
                            <div className='mu' onClick={() => this.props.history.push('/empty')}>
                                <img src={c9} ></img>
                                <div className='ctxt'>充电桩</div>
                            </div>
                            {/* <div className='mu' onClick={() => this.props.history.push('/jumppage')}>
                                <img src={c6} ></img>
                                <div className='ctxt'>生活服务</div>
                            </div> */}
                            {/* <div className='mu' >
                                <wx-open-launch-weapp
                                    id="launch-btn"
                                    appid={lxddtappId}
                                    // username={username}
                                    // path="pages/index/index.html"
                                >
                                    <script type="text/wxtag-template">
                                        <div style={{textAlign:'center'}}>
                                            <img src={c6} style={{width:'36px',height:'34px',}}></img>
                                            <div className='ctxt' style={{color:'#303030',fontSize:'14px',marginTop:'2px'}}>生活服务</div>
                                        </div>
                                    </script>
                                </wx-open-launch-weapp>
                            </div> */}
                        </div>
                        <div className="safetyBar">
                            <div className="safety" onClick={() => this.props.history.push('/security')}>
                                <i className="icon iconfont iconyijianbaojing" />
                                <span>一键报警</span>
                                <i className="icon iconfont icontiaozhuan" />
                            </div>
                            <div className="safety">
                                <a href="tel:400-138-9889">
                                    <i className="icon iconfont iconkefu" />
                                    <span>联系客服</span>
                                </a>
                                <i className="icon iconfont icontiaozhuan" />
                            </div>
                        </div>
                        {this.state.orderinfo.startCity && (
                            <div className='list'>
                                <div className="status_home">待出行</div>
                                <div className='vcontent'>
                                    <div className="flex-cbetween">
                                        <div className="city">{this.state.orderinfo.startCity}</div>
                                        <img className="car" src={car}></img>
                                        <div className='city'>{this.state.orderinfo.endCity}</div>
                                    </div>
                                    <div className='flexg'></div>
                                    <div className="flex-cbetween">
                                        <div className="bluecolor">预计{this.state.orderinfo.startTime}出发</div>
                                        <div className="greycolor">{this.state.orderinfo.startDate}{this.state.orderinfo.weekend}</div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className='huodongbox'>
                            <img className='b1' src={b1} onClick={() => this.props.history.push('/recruitDrivers')}></img>
                            <div className=''>
                                <img className='b2' src={b2} onClick={() => this.props.history.push('/exchangeCoupon')}></img>
                                <img className='b3' src={b3} onClick={() => this.props.history.push('/promote')}></img>
                            </div>
                        </div>
                        <img className='guanggao' src={banner1}></img>
                        {/* <div className='launchdiv'>
                            <wx-open-launch-weapp
                                id="launch-btn1"
                                appid={lxddtappId}
                            >
                                <script type="text/wxtag-template">
                                    <div style={{width:'100%',height:'100px'}}></div>
                                </script>
                            </wx-open-launch-weapp>
                            <img src={banner1} style={{width:'100%',height:'100px'}} ></img>
                        </div> */}
                    </div>
                    <DatePicker
                        mode="time"
                        visible={this.state.visible}
                       onDismiss={() => {
                            this.setState({visible:false})
                        }}
                      onOk={val => {
                        let params = {
                            source: 1,
                            token:this.props.userInfo.token,
                            data:{
                                startPosition:this.state.cjstartPoi,
                                endPosition:this.state.endAddress  == "昆明市" ? "25.082654_102.738151" : this.state.cjendPoi,
                                lineIds:this.state.lineIds,
                                startDate:this.state.startDateVal + ' ' +moment(val).format("HH:mm:00")
                            },
                        };
                        searchBytime(params).then((res)=>{
                            if(res.data.code == "0000"){
                                this.setState({visible:false,classData:res.data.data})
                                Modal.alert('温馨提示', <div className='refundText'>根据您选择的乘车时间，为您推荐的 出发时间为<span>{res.data.data.startTime}</span>是否同意？</div>, [
                                    { text: '不同意',style: {color: '#3679FE', backgroundColor: '#f9f9f9', }},
                                    { text: '同意', style: {color: '#fff', backgroundColor: '#3679FE', }, onPress: () => this.goShiftPage(res.data.data)},
                                ])
                            }else{
                                Toast.info(res.data.msg)
                            }
                        })
                      }}
                        minuteStep={10}
                        title=""
                    ></DatePicker>
                </div>
            )
        }
        if (this.state.tabIndex == 1) {
            return <CharteredBus {...this.props} province={this.state.province}/>
        }
        if (this.state.tabIndex == 2) {
            return (
                <InsideCity
                    {...this.props}
                    userPoint={this.state.userPoint}
                    initPoi={poi}
                    currentCity={this.state.currentCity}
                    startCity={this.state.cityStartCity}
                    position={this.state.position}
                    startAddress={this.state.cityStartAddress}
                    address={this.address.bind(this)}
                    websocketTime={websocketTime}
                    tabChange={this.tabChange.bind(this)}
                />
            )
        }
        if (this.state.tabIndex == 3) {
            return <RunCar {...this.props} poi={poi} currentCity={this.state.currentCity}/>
        }
        if (this.state.tabIndex == 4) {
            return <BringGoods {...this.props} poi={poi} province={this.state.province}/>
        }
    };

     //获取开始城市列表
     getStartCityList = (province, letter) => {
        this.setState({ searchValue:'',cityModal: true, cityType: "intercity",modalType:'start', province: province ,});
        this.getHistory(0)
        this.getHotData();
        const params = {
            source: 1,
            token: this.props.userInfo.token,
            data: {
                displayName: '',
                provinceName: province === "全部" ? "" : province,
                label: letter,
            },
        };
        Toast.loading('正在加载', 0);
        startCity(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.hide();
                this.setState({ cityData: res.data.data });
                let curList = [];
                let cityName = [];
                for (let k in res.data.data) {
                    curList = curList.concat(res.data.data[k]);
                }
                curList.map((res, i) => {
                    cityName.push(res.name);
                });
                //获取附近站点接口
                if (cityName.indexOf(this.state.currentCity) > -1 && nearbySite !== null) {
                    //如果列表中有附近站点的话就展示
                    this.setState({ nearbySite: nearbySite });
                } else {
                    this.setState({ nearbySite: [] });
                }
            } else {
                Toast.info(res.data.msg, 3)
            }
        })
    };
    getEndCityList(v){
        if(this.state.startAddress == "哪儿上车？"){
            Toast.info("请选择上车地址", 3)
            return
        }
        this.getHistory(1)
        this.setState({ searchValue:'',modalType:'end',cityModal: true, cityType: "intercity",});
        const params = {
            source: 1,
            token:this.props.userInfo.token,
            data:{
                position:this.state.cjstartPoi,
                label:v,
            }
        };
        Toast.loading('正在加载', 0);
        let newHotData = []
        endCity(params).then((res) => {
            if (res.data.code === '0000') {
                let curList = [];
                let cityName=[];
                for (let k in res.data.data) {
                    curList = curList.concat(res.data.data[k]);
                }
                curList.map((res,i)=>{
                    cityName.push(res.name);
                });
                this.state.hotData.map((n)=>{
                    if(cityName.indexOf(n.name) > -1){
                        newHotData.push(n)
                    }
                });
                this.setState({cityData: res.data.data,hotData:newHotData});
                Toast.hide();
            }else{
                Toast.info(res.data.msg,3)
            }
        })
    }
    timeChange(){
        if(this.state.startAddress == "哪儿上车？" || this.state.endAddress == "您想去哪？"){
            Toast.info("请选择上下车地址", 3)
            return
        }
        
        document.getElementsByTagName('body')[0].style.overflowY = 'hidden';
        this.setState({show:true,config:{},})
    }
    onConfirm = (startTime, endTime) => {
        if(this.state.province == '广西壮族自治区' || this.state.district == '惠水县'){
            this.setState({visible:true})
        }else{
            let shifList = []
            let params = {
                source: 1,
                token:this.props.userInfo.token,
                data:{
                    startCity:this.state.startCity,
                    startAddress:this.state.startAddress,
                    startPosition:this.state.cjstartPoi,
                    endCity:this.state.currentEndCity,
                    endAddress:this.state.endAddress  == "昆明市" ? "民途出行北市区集散中心" : this.state.endAddress,
                    endPosition:this.state.endAddress  == "昆明市" ? "25.082654_102.738151" : this.state.cjendPoi,
                    lineIds:this.state.lineIds,
                    startDate:moment(startTime).format('YYYY-MM-DD')
                },
            };
            getShiftList(params).then((res)=>{
                if(res.data.code == "0000"){
                    if(res.data.data.shiftCarResults.length > 0){
                        res.data.data.shiftCarResults.map((n)=>{
                            if(n.remainingSeat > 0){
                                shifList.push(n)
                            }
                        })
                        if(shifList.length == 0){
                            Toast.info('当日暂无可预约座位',3)
                        }else{
                            this.props.history.push('/selectShift',{...params.data,type:'address',dateType:'home'});
                        }
                        this.setState({shiftData:res.data.data})
                    }else{
                        Toast.info("当日暂无可预约座位", 3)
                    }
                }else{
                    Toast.info(res.data.msg)
                }                
            })
        }
        
        document.getElementsByTagName('body')[0].style.overflowY = this.originbodyScrollY;
        this.setState({
            show: false,
            startDateVal:moment(startTime).format('YYYY-MM-DD')
        });

    };

    onCancel = () => {
        document.getElementsByTagName('body')[0].style.overflowY = this.originbodyScrollY;
        this.setState({
            show: false,
        });
    };
    goShiftPage(data){
        let params = {
            id:data.id,//班次id
            startStationId:data.startStationId,//出发站点id
            startPosition:this.state.cjstartPoi,//出发经纬度
            startAddress:this.state.startAddress,
            endStationId:data.endStationId,
            endPosition:this.state.cjendPoi,
            endAddress:this.state.endAddress,
            specialPage:data.specialPage,
            remainingSeat:data.remainingSeat,
        };
        if(data.choiceSeat && data.choiceSeat == 1){
            this.props.history.push('/pay/SelectSeatSpecial',params);
        }else{
            this.props.history.push('/pay/selectSeat',params);
        }
    }
    getHistory(type){
        const params = {
            source:1,
            token:this.props.userInfo.token,
            data:{type:type},
        };
        historyStation(params).then((res)=>{
            if (res.data.code === '0000') {
                this.setState({historyDatas: res.data.data});
            }else{
                Toast.info(res.data.msg,3)
            }
        })
    }
    setoftenAddress(res){
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data: {
                address:res.title,
                location:res.point.lat+'_'+res.point.lng,
                code:res.adcode,
                type:this.state.currentChange == '家庭' ? 1 : 2,
            }
        };
        changeUserHotAddress(params).then((res)=>{
            if(res.data.code == '0000'){
                this.setState({setaddressmodal:false,poiList: [],searchValue:'',})
                this.getAddress()
            }else{
                Toast.info(res.data.msg,3);
            }
        })
    }
    render() {
        if (this.props.userInfo.isLoggedIn === false) {
            return null
        }
        const defaultOptions = {
            loop: false,
            autoplay: true,
            animationData: animationData,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };
        const mapOptions = {
            loop: false,
            autoplay: true,
            animationData: mapData,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };
        return  <div className="homeScreen" id='screen'>
            <NavBar
                className="navBar"
                style={this.state.tabIndex == 2 ? {background:'none'} : null }
                mode="light"
                icon={<i className="icon iconfont icongerenzhongxin" onClick={() => this.props.history.push('/pay/myPage', 'home')} />}
                rightContent={[
                    <i className="icon iconfont iconhuodong" onClick={() => this.props.history.push('/pay/activity')} key='iconhuodong' />,
                ]}
            >
                <div><img src={mtlogo} /></div>
                {
                    this.state.tabIndex == 0 || this.state.tabIndex == 2 ? null : <div className="tabDiv">
                    {this.state.tabs.map((res, i) => (
                        <div key={i} className={this.state.tabIndex == i ? "box boxColor" : "box"} onClick={() => this.tabChange(res, i)}>{res.title}</div>
                    ))}
                </div>
                }
            </NavBar>
            <div className="content" >
                <div id="mapContainer" style={this.state.tabIndex == 2 ? {height:'50%'}:{zIndex:0,overflow:'hidden'}}/>
                {this.state.curTips == "" ||  this.state.tabIndex == 2 ? null : <div className="errTips" ><span>{this.state.curTips}</span></div>}
                <Lottie
                    style={{ position: "absolute", marginLeft: -36, top: this.state.position.top - 62, left: this.state.position.left }}
                    options={defaultOptions}
                    height={34}
                    width={36}
                    isStopped={this.state.isStopped}
                    isPaused={this.state.isPaused} />
                <Lottie
                    style={this.state.tabIndex == 2 ? { position: "absolute", bottom: "80%", left: "50%", marginLeft: -14, }:{ position: "absolute", bottom: "53%", left: "50%", marginLeft: -14, }}
                    options={mapOptions}
                    height={52}
                    width={28}
                    isStopped={this.state.isStopped}
                    isPaused={this.state.isPaused} />
                {this.changeBody()}
            </div>
            
            {
                this.state.indexModal ?
                    <div className="indexModal">
                        <div className="backwhite">
                            {this.state.modalImage.map((res, i) => (
                                <div className="imgContent" key={i}>
                                    <div><img src={res.url} /></div>
                                    <p>{res.name}</p>
                                </div>
                            ))}
                        </div>
                    </div> : null
            }
            {
                this.state.mapModel ? <div className='searchModal' >
                {
                    this.state.modalType == 'start' ? <div className="topBar">
                        <div className='box'>
                            <div className="selCity">
                                <i className="icon iconfont iconfanhui" onClick={() => this.closeaddress()} />
                                <span onClick={() => this.getStartCityList(this.state.province)}>{this.state.startCity}</span>
                            </div>
                            <div className='circleS'></div>
                            <InputItem
                                className="searchBar"
                                ref={ref => this.autoFocusInst = ref}
                                value={this.state.searchValue}
                                placeholder="哪儿上车？"
                                onChange={this.searchChange}
                            ></InputItem>
                        </div>
                    </div>:<div className="topBar">
                    <div className='box bgcolor'>
                        <div className="selCity "><i className="icon iconfont iconfanhui" onClick={() => this.closeaddress()} /><span>{this.state.startCity}</span></div>
                        <div className='circleS'></div>
                        <div className="startAddress">{this.state.startAddress}</div>
                    </div>
                    <div className='box' >
                        <div className="selCity" onClick={() => this.getEndCityList()}><span>{this.state.currentEndCity}</span></div>
                        <div className='circleS circleE'></div>
                        <InputItem
                            className="searchBar"
                            ref={ref => this.autoFocusInst = ref}
                            value={this.state.searchValue}
                            placeholder="您要去哪儿"
                            onChange={this.searchChange}
                        ></InputItem>
                    </div>
                </div>
            }
                
                <div className="bottom2">
                    <div className="addressText">
                            <i className="icon iconfont iconchufadi"/>
                        <p>{this.state.modalType == 'start' ? this.state.startAddress : this.state.endAddress}</p>
                    </div>
                    <div className="btn"><button onClick={()=> this.goSelClass()}>去打车</button></div>
                </div>
                <div className={this.state.modalType == 'start' ? "poiList" : "poiList poiList1"}  style={this.state.poiListFlag === false  ? {height:'0'} : {height:'100%'}} ref={dom => {this.tabDOM = dom}}>
                    <div>
                        <div className="history"><i className="icon iconfont iconlishi" />历史记录</div>
                        {this.state.historyAddress && this.state.historyAddress.title !== null ? <div className="historyText" onClick={() => this.goSelClass(this.state.historyAddress,'end')}>{this.state.historyAddress.title}</div> : <div className="historyText">暂无历史记录</div>}
                        <div className="mapSel" onClick={() => {
                            this.setState({poiList: [],poiListFlag:false,searchValue:'',})
                            checkDragend = true;
                        }}><i className="icon iconfont iconditushangxuandian" />在地图上选点</div>
                    </div>
                    {
                        this.state.poiList.length > 0 ? (
                            <div className="list">
                                {
                                    this.state.poiList.map((res, i) => (
                                        <div className="item" key={i} onClick={() => this.goSelClass(res)} >
                                            <i className="icon iconfont icondituliebiaotubiao" />
                                            <div>
                                                <div>{res.title}</div>
                                                <span>{res.address}</span>
                                            </div>
                                        </div>

                                    ))
                                }
                            </div>
                        ) : <div className='tishi'>请输入搜索内容</div>
                    }
                </div>
                
            </div>:null
            }
                
            {this.searchChangeCity()}
            <CityModal
                modal={this.state.cityModal}
                modalType={this.state.modalType}//出发还是到达的modal
                onClose={this.onClose.bind(this)}
                data={this.state.cityData}//城市列表数据
                changeCity={this.changeCity.bind(this)}//切换城市事件
                cityType={this.state.cityType}//乘车类型
                hotData={this.state.hotData}//热门地州
                historyData={this.state.historyDatas}//热门地州
                nearbySite={this.state.nearbySite}//附近站点
                province={this.state.province}
                getStartCityList={this.getStartCityList.bind(this)}
                getEndCityList={this.getEndCityList.bind(this)}
                {...this.props}
            />
            <Calendar
                {...this.state.config}
                visible={this.state.show}
                onCancel={this.onCancel}
                onConfirm={this.onConfirm}
                defaultDate={now}
                minDate={now}
                // maxDate={new Date(+now + 1209600000)}
                defaultTimeValue={now}
                type="one"
            />
            <Modal
                className="bgModal"
                visible={this.state.bgModal}
                transparent
                maskClosable={true}
                onClose={() => this.onClose('bgModal')}
                footer={[
                    { text: <i className="icon iconfont iconguanggaoguanbi" />, onPress: () => { this.onClose('bgModal') } }
                ]}
            >
                <Carousel autoplay={true} infinite >
                    <img
                        src={qb1}
                        onClick={() => {
                            this.onClose('bgModal');
                            this.props.history.push('/pay/myPage', 'home')
                        }
                        }
                        style={{ width: '100%', verticalAlign: 'top' }}
                        onLoad={() => {
                            window.dispatchEvent(new Event('resize'));
                        }}
                    />
                    <img
                        src={qianbao}
                        style={{ width: '100%', verticalAlign: 'top' }}
                        onLoad={() => {
                            window.dispatchEvent(new Event('resize'));
                        }}
                    />
                    <img
                        src={ynbg}
                        alt=""
                        style={{ width: '100%', verticalAlign: 'top' }}
                        onLoad={() => {
                            window.dispatchEvent(new Event('resize'));
                        }}
                    />
                    <img
                        src={gzbg}
                        alt=""
                        style={{ width: '100%', verticalAlign: 'top' }}
                        onLoad={() => {
                            window.dispatchEvent(new Event('resize'));
                        }}
                    />
                </Carousel>
            </Modal>
            <Modal
                    className="modalClass"
                    animationType="slide-up"
                    popup
                    // maskClosable={false}
                    visible={this.state.modal}
                    onClose={()=>{this.setState({modal:false})}}
                >
                    <div className="content1">
                        <div className='first'onClick={()=>{
                            this.setState({setaddressmodal:true,searchValue:'',poiList: [],modal:false})
                        }}>修改{this.state.currentChange}地址</div>
                        <div onClick={()=>{
                            let params = {
                                source:1,
                                token: this.props.userInfo.token,
                                data: {type:this.state.currentChange == '家庭' ? 1 : 2,}
                            };
                            delUserHotAddress(params).then((res)=>{
                                if(res.data.code == '0000'){
                                    this.setState({modal:false})
                                    this.getAddress()
                                }else{
                                    Toast.info(res.data.msg,3);
                                }
                            })
                        }}>删除{this.state.currentChange}地址</div>
                        <div className='cancel' onClick={()=>{this.setState({modal:false})}}>取消</div>
                    </div>
                </Modal> 
                <Modal
                    className="seraddressmodalClass"
                    animationType="slide-up"
                    // maskClosable={false}
                    visible={this.state.setaddressmodal}
                    onClose={()=>{this.setState({setaddressmodal:false})}}
                >
                    <div className="content1">
                        <div className="topBar">
                            <div className='box'>
                                <i className="icon iconfont iconfanhui" onClick={() =>{
                                     this.setState({setaddressmodal:false,poiList: [],searchValue:'',})
                                }} />
                                <InputItem
                                    className="searchBar"
                                    ref={ref => this.autoFocusInst = ref}
                                    value={this.state.searchValue}
                                    placeholder={`设置${this.state.currentChange}地址`}
                                    onChange={this.searchChange}
                                ></InputItem>
                            </div>
                        </div>
                        <div className="poiList" style={this.state.poiListFlag === false  ? {height:'0'} : {height:'100%'}} ref={dom => {this.tabDOM = dom}}>
                            {
                                this.state.poiList.length > 0 ? (
                                    <div className="list">
                                        {
                                            this.state.poiList.map((res, i) => (
                                                <div className="item"  key={i}  onClick={() => this.setoftenAddress(res)} >
                                                    <i className="icon iconfont icondituliebiaotubiao"/>
                                                    <div>
                                                        <div>{res.title}</div>
                                                        <span>{res.address}</span>
                                                    </div>
                                                </div>

                                            ))
                                        }
                                    </div>
                                ): <div className='tishi'>请输入搜索内容</div>
                            }
                        </div>
                    </div>
                </Modal> 
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/container/Home/index.js